import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { hayvancılikApi as hayvancilikApi, tanimlarApi } from '../services/api';
import DataTable, { DtColumn } from '../components/DataTable';
import { GUNCEL_AY, cozGuncelAy } from '../utils/guncelAy';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const AYLAR = ['', 'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
               'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
const YIL = new Date().getFullYear();

async function getTanimlar(modul: string) {
  const res = await fetch(`${API}/api/tanimlar2/liste?modul=${modul}&sadece_yaprak=true`, { headers: headers() });
  return res.ok ? res.json() : [];
}

const emptyForm = {
  isletme_id: '', yil: YIL, ay: new Date().getMonth() + 1,
  tur_kod: 'H.2.1.1', tur: 'Koyun', irk_kod: '', irk: '',
  koc_teke_sayisi: 0, ana_sayisi: 0,
  erkek_toklu_sayisi: 0, disi_toklu_sayisi: 0,
  erkek_kuzu_sayisi: 0, disi_kuzu_sayisi: 0,
  reforme_sayisi: 0, sagmal_sayisi: 0,
  sut_uretimi_kg: 0, kuzu_oglak_dogum: 0, kuzu_oglak_olum: 0,
  damizlik_satis: 0, aciklama: ''
};

export default function Kucukbas() {
  const [kayitlar, setKayitlar] = useState<any[]>([]);
  const [isletmeler, setIsletmeler] = useState<any[]>([]);
  const [ozet, setOzet] = useState<any>(null);
  const [secili, setSecili] = useState<any>(null);
  const [modalAcik, setModalAcik] = useState(false);
  const [form, setForm] = useState<any>({ ...emptyForm });
  const [filtre, setFiltre] = useState((() => {
    const sp = new URLSearchParams(window.location.search);
    return {
      isletme_id: sp.get('isletme') || '',
      yil: Number(sp.get('yil') || YIL),
      ay: sp.get('ay') || GUNCEL_AY
    };
  })());
  const [hata, setHata] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);
  const [excelMesaj, setExcelMesaj] = useState('');

  // Tanımlar'dan gelen listeler
  const [turler, setTurler] = useState<any[]>([]);           // kucukbas_tur
  const [koyunIrklar, setKoyunIrklar] = useState<any[]>([]); // H.2.1.1 altındaki ırklar
  const [keciIrklar, setKeciIrklar] = useState<any[]>([]);   // H.2.1.2 altındaki ırklar

  const userStr = localStorage.getItem('user');
  const user = userStr ? JSON.parse(userStr) : null;
  const isGM = user?.rol && ['super_admin', 'gm_yonetici', 'gm_personel'].includes(user.rol);
  const isAdmin = user?.rol && ['super_admin', 'gm_yonetici'].includes(user.rol);

  // Seçili türe göre ırk listesi
  const aktifIrklar = form.tur_kod === 'H.2.1.1' ? koyunIrklar : keciIrklar;

  const [kiralikGoster, setKiralikGoster] = useState(false);

  useEffect(() => {
    if (!isGM && user?.isletme_id) {
      setFiltre(f => ({ ...f, isletme_id: user.isletme_id }));
      setForm((f: any) => ({ ...f, isletme_id: user.isletme_id }));
    }
    // Tür listesi: Koyun (H.2.1.1) ve Keçi (H.2.1.2) - sadece yaprak türler
    getTanimlar('kucukbas_tur').then(setTurler);
    // Koyun ırkları: H.2.1.1 altındaki tüm torunlar (yaprak) — modul filtresi yok, ust yeterli
    fetch(`${API}/api/tanimlar2/liste?ust=H.2.1.1&sadece_yaprak=true`, { headers: headers() })
      .then(r => r.json()).then(setKoyunIrklar);
    // Keçi ırkları: H.2.1.2 altındaki tüm torunlar (yaprak)
    fetch(`${API}/api/tanimlar2/liste?ust=H.2.1.2&sadece_yaprak=true`, { headers: headers() })
      .then(r => r.json()).then(setKeciIrklar);
  }, []);

  useEffect(() => {
    tanimlarApi.isletmelerListesi(kiralikGoster).then(r => setIsletmeler(r.data));
  }, [kiralikGoster]);

  useEffect(() => { yukle(); }, [filtre]);

  const [cozulenAy, setCozulenAy] = useState<number | null>(null);

  const yukle = async () => {
    let ay: any = filtre.ay;
    if (ay === GUNCEL_AY) {
      ay = await cozGuncelAy(filtre.yil, filtre.isletme_id, hayvancilikApi.kucukbasList);
      setCozulenAy(ay);
    } else {
      setCozulenAy(null);
    }
    const params: any = { yil: filtre.yil };
    if (filtre.isletme_id) params.isletme_id = filtre.isletme_id;
    if (ay) params.ay = ay;
    hayvancilikApi.kucukbasList(params).then(r => setKayitlar(r.data)).catch(() => setKayitlar([]));
    hayvancilikApi.kucukbasOzet({ yil: filtre.yil, ...(filtre.isletme_id ? { isletme_id: filtre.isletme_id } : {}), ...(ay ? { ay } : {}) })
      .then(r => setOzet(r.data)).catch(() => setOzet(null));
  };

  const irkAdi = (kod: string) => {
    const t = [...koyunIrklar, ...keciIrklar].find(i => i.kod === kod);
    return t ? t.ad : kod;
  };

  const turAdi = (kod: string) => {
    const t = turler.find(i => i.kod === kod);
    return t ? t.ad : kod;
  };

  const duzenleAc = (k: any) => {
    setSecili(k);
    setForm({ ...k, tur_kod: k.tur_kod || 'H.2.1.1', irk_kod: k.irk_kod || '' });
    setHata(''); setModalAcik(true);
  };

  const kaydet = async () => {
    if (!form.isletme_id) { setHata('İşletme seçiniz'); return; }
    if (!form.tur_kod) { setHata('Tür seçiniz'); return; }
    setHata(''); setYukleniyor(true);
    try {
      const body = {
        ...form,
        isletme_id: Number(form.isletme_id),
        tur: turAdi(form.tur_kod), tur_kod: form.tur_kod,
        irk: form.irk_kod ? irkAdi(form.irk_kod) : (form.irk || ''),
        irk_kod: form.irk_kod,
      };
      if (secili) {
        await axios.put(`${API}/api/hayvancilik/kucukbas/${secili.id}`, body, { headers: headers() });
      } else {
        await hayvancilikApi.kucukbasSave(body);
      }
      yukle(); setModalAcik(false); setSecili(null); setForm({ ...emptyForm });
    } catch (e: any) { setHata(e.response?.data?.detail || 'Hata oluştu'); }
    finally { setYukleniyor(false); }
  };

  const sil = async (id: number) => {
    if (!window.confirm('Bu kaydı silmek istiyor musunuz?')) return;
    try { await hayvancilikApi.kucukbasDelete(id); yukle(); } catch {}
  };

  const silSecili = async (rows: any[]) => {
    for (const k of rows) { try { await hayvancilikApi.kucukbasDelete(k.id); } catch {} }
    yukle();
  };

  const kucukbasColumns: DtColumn[] = [
    { key: 'isletme', label: 'İşletme', sortable: true, filterable: true, render: (k: any) => <><strong>{k.isletme_kod}</strong><br /><small>{k.isletme_ad}</small></>, sortValue: (k: any) => k.isletme_kod || '', filterValue: (k: any) => k.isletme_ad || '', exportValue: (k: any) => `${k.isletme_kod} ${k.isletme_ad}` },
    { key: 'yil', label: 'Yıl', sortable: true, filterable: true, sortValue: (k: any) => Number(k.yil), filterValue: (k: any) => String(k.yil) },
    { key: 'ay', label: 'Ay', sortable: true, filterable: true, render: (k: any) => AYLAR[k.ay] || k.ay, filterValue: (k: any) => AYLAR[k.ay] || String(k.ay), sortValue: (k: any) => Number(k.ay) },
    { key: 'tur', label: 'Tür', sortable: true, filterable: true, filterValue: (k: any) => k.tur || '' },
    { key: 'irk', label: 'Irk', sortable: true, filterable: true, render: (k: any) => k.irk || '—', filterValue: (k: any) => k.irk || '' },
    { key: 'koc_teke', label: 'Koç/Teke', sortable: true, render: (k: any) => n(k.koc_teke_sayisi), sortValue: (k: any) => Number(k.koc_teke_sayisi || 0) },
    { key: 'ana', label: 'Koyun/Keçi', sortable: true, render: (k: any) => n(k.ana_sayisi), sortValue: (k: any) => Number(k.ana_sayisi || 0) },
    { key: 'e_toklu', label: 'E.Toklu', sortable: true, render: (k: any) => n(k.erkek_toklu_sayisi), sortValue: (k: any) => Number(k.erkek_toklu_sayisi || 0) },
    { key: 'd_toklu', label: 'D.Toklu', sortable: true, render: (k: any) => n(k.disi_toklu_sayisi), sortValue: (k: any) => Number(k.disi_toklu_sayisi || 0) },
    { key: 'e_kuzu', label: 'E.Kuzu', sortable: true, render: (k: any) => n(k.erkek_kuzu_sayisi), sortValue: (k: any) => Number(k.erkek_kuzu_sayisi || 0) },
    { key: 'd_kuzu', label: 'D.Kuzu', sortable: true, render: (k: any) => n(k.disi_kuzu_sayisi), sortValue: (k: any) => Number(k.disi_kuzu_sayisi || 0) },
    { key: 'reforme', label: 'Reforme', sortable: true, render: (k: any) => n(k.reforme_sayisi), sortValue: (k: any) => Number(k.reforme_sayisi || 0) },
    { key: 'sagmal', label: 'Sağmal', sortable: true, render: (k: any) => n(k.sagmal_sayisi), sortValue: (k: any) => Number(k.sagmal_sayisi || 0) },
    { key: 'toplam', label: 'Toplam', sortable: true, render: (k: any) => <strong>{n(k.toplam_hayvan)}</strong>, sortValue: (k: any) => Number(k.toplam_hayvan || 0) },
    { key: 'sut', label: 'Süt (kg)', sortable: true, render: (k: any) => n(k.sut_uretimi_kg), sortValue: (k: any) => Number(k.sut_uretimi_kg || 0) },
    { key: 'islem', label: 'İşlem', noExport: true, render: (k: any) => (
      <div style={{ display: 'flex', gap: 4 }}>
        {isAdmin && <button className="btn btn-primary btn-sm" onClick={() => duzenleAc(k)}>Düzenle</button>}
        <button className="btn btn-danger btn-sm" onClick={() => sil(k.id)}>Sil</button>
      </div>
    )},
  ];

  const [cakismaModal, setCakismaModal] = useState(false);
  const [cakismalar, setCakismalar] = useState<any[]>([]);
  const [cakismaYeniSayisi, setCakismaYeniSayisi] = useState(0);
  const [bekleyenDosya, setBekleyenDosya] = useState<File | null>(null);

  const excelYukle = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]; if (!file) return;
    e.target.value = '';
    await excelGonder(file, '');
  };

  const excelGonder = async (file: File, cakisma: string) => {
    setExcelMesaj('Yükleniyor...');
    try {
      const res = await hayvancilikApi.kucukbasExcel(file, cakisma);
      if (res.data.bekliyor) {
        setBekleyenDosya(file);
        setCakismalar(res.data.cakismalar);
        setCakismaYeniSayisi(res.data.yeni_sayisi);
        setCakismaModal(true);
        setExcelMesaj('');
        return;
      }
      setExcelMesaj(`✅ ${res.data.basarili} kayıt aktarıldı${res.data.hatali_sayisi > 0 ? `, ${res.data.hatali_sayisi} hata` : ''}`);
      yukle();
    } catch { setExcelMesaj('❌ Excel yüklenemedi'); }
  };

  const cakismaKarar = async (karar: 'yaz' | 'atla') => {
    if (!bekleyenDosya) return;
    setCakismaModal(false);
    await excelGonder(bekleyenDosya, karar);
    setBekleyenDosya(null);
  };

  const n = (v: any) => (v ?? 0).toLocaleString('tr-TR');

  return (
    <div>
      {cakismaModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:9999, display:'flex', alignItems:'center', justifyContent:'center' }}>
          <div style={{ background:'#fff', borderRadius:8, padding:28, width:520, maxWidth:'95vw', maxHeight:'80vh', display:'flex', flexDirection:'column', gap:16 }}>
            <div style={{ fontWeight:700, fontSize:16, color:'#c0392b' }}>⚠️ Mevcut Kayıtlar Bulundu</div>
            <div style={{ fontSize:13, color:'#555' }}>
              Aşağıdaki <strong>{cakismalar.length} kayıt</strong> sistemde zaten mevcut.
              {cakismaYeniSayisi > 0 && <span> Yeni kayıt sayısı: <strong>{cakismaYeniSayisi}</strong>.</span>}
            </div>
            <div style={{ overflowY:'auto', maxHeight:300, border:'1px solid #eee', borderRadius:4 }}>
              {cakismalar.map((c, i) => (
                <div key={i} style={{ padding:'6px 10px', borderBottom:'1px solid #f0f0f0', fontSize:12, color:'#333' }}>
                  Satır {c.satir}: {c.ozet}
                </div>
              ))}
            </div>
            <div style={{ display:'flex', gap:10, justifyContent:'flex-end', flexWrap:'wrap' }}>
              <button className="btn" style={{ background:'#e74c3c', color:'#fff' }} onClick={() => cakismaKarar('yaz')}>Üzerine Yaz</button>
              <button className="btn" style={{ background:'#27ae60', color:'#fff' }} onClick={() => cakismaKarar('atla')}>Atla (Sadece Yenileri Ekle)</button>
              <button className="btn" style={{ background:'#95a5a6', color:'#fff' }} onClick={() => { setCakismaModal(false); setBekleyenDosya(null); setExcelMesaj('İptal edildi'); }}>İptal</button>
            </div>
          </div>
        </div>
      )}
      <div className="page-header">
        <h1>🐑 Küçükbaş Hayvancılık</h1>
        <p>İşletme bazında aylık küçükbaş hayvan verileri</p>
      </div>

      {ozet && (
        <div className="stats-grid">
          <div className="stat-card"><div className="stat-icon">🐑</div><div><div className="stat-value">{n(ozet.toplam_hayvan)}</div><div className="stat-label">Toplam Hayvan</div></div></div>
          <div className="stat-card"><div className="stat-icon">🐑</div><div><div className="stat-value">{n(ozet.koyun_toplam)}</div><div className="stat-label">Koyun Sayısı</div></div></div>
          <div className="stat-card"><div className="stat-icon">🐐</div><div><div className="stat-value">{n(ozet.keci_toplam)}</div><div className="stat-label">Keçi Sayısı</div></div></div>
          <div className="stat-card"><div className="stat-icon">🥛</div><div><div className="stat-value">{n(Math.round(ozet.koyun_sut_kg))}</div><div className="stat-label">Koyun Sütü (kg)</div></div></div>
          <div className="stat-card"><div className="stat-icon">🥛</div><div><div className="stat-value">{n(Math.round(ozet.keci_sut_kg))}</div><div className="stat-label">Keçi Sütü (kg)</div></div></div>
        </div>
      )}

      <div className="card">
        <div className="toolbar">
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <input type="number" className="search-input" style={{ width: 90 }} value={filtre.yil}
              onChange={e => setFiltre({ ...filtre, yil: Number(e.target.value) })} placeholder="Yıl" />
            <select className="search-input" style={{ width: 130 }} value={filtre.ay}
              onChange={e => setFiltre({ ...filtre, ay: e.target.value })}>
              <option value={GUNCEL_AY}>Güncel Ay{cozulenAy ? ` (${AYLAR[cozulenAy]})` : ''}</option>
              <option value="">Tüm Aylar</option>
              {AYLAR.slice(1).map((a, i) => <option key={i+1} value={i+1}>{a}</option>)}
            </select>
            {isGM && (
              <>
                <select className="search-input" style={{ width: 200 }} value={filtre.isletme_id}
                  onChange={e => setFiltre({ ...filtre, isletme_id: e.target.value })}>
                  <option value="">Tüm İşletmeler</option>
                  {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
                </select>
                <label style={{ display:'flex', alignItems:'center', gap:4, fontSize:13, cursor:'pointer', whiteSpace:'nowrap' }}>
                  <input type="checkbox" checked={kiralikGoster} onChange={e => setKiralikGoster(e.target.checked)} />
                  Kiralıkları Göster
                </label>
              </>
            )}
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            {excelMesaj && <span style={{ fontSize: 12, color: '#555' }}>{excelMesaj}</span>}
            <label className="btn" style={{ background: '#2ecc71', color: 'white', cursor: 'pointer' }}>
              📥 Excel Yükle
              <input type="file" accept=".xlsx,.xls" style={{ display: 'none' }} onChange={excelYukle} />
            </label>
            <button className="btn btn-success" onClick={() => { setForm({ ...emptyForm, isletme_id: isGM ? '' : user?.isletme_id }); setHata(''); setModalAcik(true); }}>+ Yeni Kayıt</button>
          </div>
        </div>

        <DataTable columns={kucukbasColumns} data={kayitlar} rowKey={(k: any) => k.id} onDeleteSelected={silSecili} exportFilename="kucukbas-hayvancilik" />
      </div>

      {modalAcik && (
        <div className="modal-overlay" onClick={() => setModalAcik(false)}>
          <div className="modal" style={{ width: 640 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>🐑 Küçükbaş Kayıt Girişi</h3>
              <button className="modal-close" onClick={() => setModalAcik(false)}>×</button>
            </div>
            <div className="modal-body">
              {hata && <div className="alert alert-danger">{hata}</div>}

              {isGM && (
                <div className="form-group">
                  <label>İşletme *</label>
                  <select className="form-control" value={form.isletme_id}
                    onChange={e => setForm({ ...form, isletme_id: e.target.value })}>
                    <option value="">Seçiniz</option>
                    {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
                  </select>
                </div>
              )}

              <div className="form-row">
                <div className="form-group">
                  <label>Tür *</label>
                  <select className="form-control" value={form.tur_kod}
                    onChange={e => {
                      const adMap: Record<string, string> = { 'H.2.1.1': 'Koyun', 'H.2.1.2': 'Keçi' };
                      setForm({ ...form, tur_kod: e.target.value, tur: adMap[e.target.value] || '', irk_kod: '', irk: '' });
                    }}>
                    <option value="H.2.1.1">Koyun (H.2.1.1)</option>
                    <option value="H.2.1.2">Keçi (H.2.1.2)</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Irk <small style={{color:'#999', fontWeight:'normal'}}>({aktifIrklar.length} ırk)</small></label>
                  <select className="form-control" value={form.irk_kod}
                    onChange={e => setForm({ ...form, irk_kod: e.target.value })}>
                    <option value="">Seçiniz</option>
                    {aktifIrklar.map(irk => (
                      <option key={irk.kod} value={irk.kod}>{irk.ad} ({irk.kod})</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Yıl *</label>
                  <input className="form-control" type="number" value={form.yil}
                    onChange={e => setForm({ ...form, yil: Number(e.target.value) })} />
                </div>
                <div className="form-group">
                  <label>Ay *</label>
                  <select className="form-control" value={form.ay}
                    onChange={e => setForm({ ...form, ay: Number(e.target.value) })}>
                    {AYLAR.slice(1).map((a, i) => <option key={i+1} value={i+1}>{a}</option>)}
                  </select>
                </div>
              </div>

              {/* Damızlık */}
              <div style={{ fontSize: 12, fontWeight: 600, color: '#666', margin: '8px 0 4px', borderBottom: '1px solid #eee', paddingBottom: 4 }}>Damızlık</div>
              <div className="form-row">
                <div className="form-group"><label>Koç/Teke</label><input className="form-control" type="number" min={0} value={form.koc_teke_sayisi} onChange={e => setForm({ ...form, koc_teke_sayisi: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Koyun/Keçi (Dişi Damızlık)</label><input className="form-control" type="number" min={0} value={form.ana_sayisi} onChange={e => setForm({ ...form, ana_sayisi: Number(e.target.value) })} /></div>
              </div>

              {/* Toklu / Çebiç */}
              <div style={{ fontSize: 12, fontWeight: 600, color: '#666', margin: '8px 0 4px', borderBottom: '1px solid #eee', paddingBottom: 4 }}>Toklu/Çebiç</div>
              <div className="form-row">
                <div className="form-group"><label>Erkek Toklu/Çebiç</label><input className="form-control" type="number" min={0} value={form.erkek_toklu_sayisi} onChange={e => setForm({ ...form, erkek_toklu_sayisi: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Dişi Toklu/Çebiç</label><input className="form-control" type="number" min={0} value={form.disi_toklu_sayisi} onChange={e => setForm({ ...form, disi_toklu_sayisi: Number(e.target.value) })} /></div>
              </div>

              {/* Kuzu / Oğlak */}
              <div style={{ fontSize: 12, fontWeight: 600, color: '#666', margin: '8px 0 4px', borderBottom: '1px solid #eee', paddingBottom: 4 }}>Kuzu/Oğlak</div>
              <div className="form-row">
                <div className="form-group"><label>Erkek Kuzu/Oğlak</label><input className="form-control" type="number" min={0} value={form.erkek_kuzu_sayisi} onChange={e => setForm({ ...form, erkek_kuzu_sayisi: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Dişi Kuzu/Oğlak</label><input className="form-control" type="number" min={0} value={form.disi_kuzu_sayisi} onChange={e => setForm({ ...form, disi_kuzu_sayisi: Number(e.target.value) })} /></div>
              </div>

              {/* Diğer */}
              <div style={{ fontSize: 12, fontWeight: 600, color: '#666', margin: '8px 0 4px', borderBottom: '1px solid #eee', paddingBottom: 4 }}>Diğer</div>
              <div className="form-row">
                <div className="form-group"><label>Reforme</label><input className="form-control" type="number" min={0} value={form.reforme_sayisi} onChange={e => setForm({ ...form, reforme_sayisi: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Sağmal (Baş)</label><input className="form-control" type="number" min={0} value={form.sagmal_sayisi} onChange={e => setForm({ ...form, sagmal_sayisi: Number(e.target.value) })} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Süt Üretimi (kg)</label><input className="form-control" type="number" min={0} value={form.sut_uretimi_kg} onChange={e => setForm({ ...form, sut_uretimi_kg: Number(e.target.value) })} /></div>
                <div className="form-group"><label>Damızlık Satış</label><input className="form-control" type="number" min={0} value={form.damizlik_satis} onChange={e => setForm({ ...form, damizlik_satis: Number(e.target.value) })} /></div>
              </div>
              <div className="form-group"><label>Açıklama</label><textarea className="form-control" value={form.aciklama} onChange={e => setForm({ ...form, aciklama: e.target.value })} rows={2} /></div>
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={() => setModalAcik(false)} style={{ background: '#eee' }}>İptal</button>
              <button className="btn btn-primary" onClick={kaydet} disabled={yukleniyor}>
                {yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
